import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { SubChannelColumns } from "../../../tableColumns/table-columns";
import { getSubChannel } from "../../../Slice/channel.slice";
import { SubChannelJson } from "../../../DynamicFormsJson/MastersJSON/subChannel";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  serverMsg,
} from "../../../config/messageconstant";
import endpoint from "../../../config/endpoints";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { apiDelete } from "../../../utils/api_service";

class SubChannelTable extends React.Component {
  constructor(props) {
    super(props);
  }

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;

    if (rowData.id) {
      showLoador({ loador: true });
      apiDelete({
        url: endpoint.subChannel + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data && data.data.statusCode == 200) {
            showNotification({ msg: deletemsg });
            window.location.reload();
          } else {
            showNotification({ msg: deleteFailedMsg, severity: "error" });
          }
        } else {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
      });
    }
  };

  render() {
    const { subChannel, getSubChannel } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={SubChannelJson.formPath}
          screenTitle={SubChannelJson.screenTitle}
          fieldMeta={SubChannelJson.fieldMeta}
          showPdfDownload={SubChannelJson.showPdfDownload}
          showExcelDownload={true}
          showExtension={false}
          filterDataExcel={true}
          pdfFileName={SubChannelJson.pdfFileName}
          excelFileName={SubChannelJson.excelFileName}
          showAddButton={SubChannelJson.showAddButton}
          tableColumnsToFilter={SubChannelJson.tableColumnsToFilter}
          tableColumns={SubChannelColumns}
          tableData={subChannel?.subChannel}
          getTableData={getSubChannel}
          apiBaseURL={SubChannelJson.apiBaseURL}
          baseIdColumn={SubChannelJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Sub Channel"}
          showDeleteIcon={true}
          isActiveURL={SubChannelJson.isActiveURL}
          deleteStaticTrue={true}
          deleteURLStatic={true}
          onDeleteStatic={this.rowDelete}
          showViewButtonInTable={true}
          formPathView={SubChannelJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  subChannel: state.channel,
});
const mapDispatchToProps = {
  getSubChannel,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(SubChannelTable);
